import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {APIClient} from "../../utils/APIClient";
import {Spinner} from "../Spinner";
import {API_URL} from "../../settings/local_settings";


export class GiveAccessAdAccountForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accountData: null,
            email: null,
            access_role: null
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    componentDidMount() {
        this.getAccountData();
    }

    // API
    getAccountData() {
        new APIClient(this.getAdAccountDataURL()).call('POST', {'channel':this.props.channel, 'channel_account_id': this.props.adAccountId}).then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    accountData: response.data
                });
            }
        });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            sendingAdAccountAccess: true
        });

        new APIClient(this.submitUrl()).call('POST', {
            'email_address': event.target.email.value,
            'channel': this.props.channel,
            'ad_account_id': this.props.adAccountId,
            'access_role': event.target.access_role.value,
        }).then((data) => {
            this.setState({
                sendingAdAccountAccess: false
            });

            if (data.status !== 'OK') {
                alert(data.error_message);
            } else if (data.status === 'OK') {
                this.props.afterSuccessfulSubmit(data.data)
            }
        });
    }

    footerButton() {
        if (this.state.sendingAdAccountAccess) {
            return <Spinner color="positive small"/>
        } else {
            return <input type="submit" value="Invitar" className="btn -submit"/>
        }
    }

    getAdAccountText() {
        if(this.state.accountData == null)
            return "loading";

        return this.state.accountData.name + " (ID: " + this.state.accountData.id + ")";
    }

    renderAccountInput() {
        return (<input name="AdAccount" type="text" value={this.getAdAccountText()} readOnly="readonly" className="form-control-plaintext"/>)
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <label>Cuenta</label>
                            {this.renderAccountInput()}
                        </div>
                        <div className="form-row">

                            <label>Tipo de acceso</label>
                            <select name="access_role" onChange={this.handleChange} defaultValue={3}>
                                <option value="2">Admin</option>
                                <option value="3">Estándar</option>
                                <option value="4">Sólo lectura</option>
                                <option value="5">Sólo email</option>
                            </select>
                        </div>
                        <div className="form-row">
                            <label>Email</label>
                            <input value={this.state.email} onChange={this.handleChange} name="email" type="text"/>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }

    handleChange(event) {
        const target = event.target;
        const name = target.name;

        this.setState({
            [name]: target.value
        });
    }

    // URLS
    getAdAccountDataURL() {
        return `${API_URL}channel_accounts/account/data`
    }

    submitUrl() {
        return `${API_URL}manage-accounts/ad-account/give-access`;
    }
}
